export { BagChannelAndLocationInfo } from './BagChannelAndLocationInfo';
